import React from 'react';
import ContentLoader from 'react-content-loader';

interface OrderConfirmationPageContentSkeletonProps {
  displayCardFooter: boolean;
}

const OrderConfirmationPageContentSkeleton: React.FC<
  OrderConfirmationPageContentSkeletonProps
> = ({ displayCardFooter }) => (
  <div className="w-full -mb-2">
    <ContentLoader height="400" width="100%" className="mb-4">
      <rect x="0" y="0" rx="8" ry="8" className="w-full h-full" />
    </ContentLoader>
    {displayCardFooter ? (
      <>
        <hr className="-mx-6" />
        <div className="mt-4">
          <ContentLoader height="36" width="160">
            <rect x="0" y="0" rx="8" ry="8" className="w-full h-full" />
          </ContentLoader>
        </div>
      </>
    ) : null}
  </div>
);

export default OrderConfirmationPageContentSkeleton;
